import styled from 'styled-components';

import { HOME, MOBILE } from '../../../../theme/tokens';
import { pulseCard } from '../../../../theme/mixins';
import { Text } from '../../../../components';

/** The metric card surface — the 32%-black wash over zinc-900 with a hairline
 *  border + 16px radius (shared with Home / Pulse via `pulseCard`). */
export const Frame = styled.div`
  ${pulseCard}
  padding: 10px;
  min-width: 0;
`;

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 5px 4px;

  ${MOBILE} {
    flex-wrap: wrap;
  }
`;

export const HeadText = styled.div`
  min-width: 0;
`;

export const Title = styled(Text)`
  display: block;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: ${HOME.t300};
`;

export const Sub = styled(Text)`
  display: block;
  font-size: 14px;
  font-weight: 300;
  color: ${HOME.t300};
  margin-top: 4px;
`;

export const Control = styled.div`
  flex-shrink: 0;
`;
